/**
 * Endereço do admin da PPS (`apps/admin`) e o destino do redirecionamento de
 * `/admin/*` no CRM e no app do jogador.
 *
 * Até 16/10/2026 o redirecionamento dependia da chave `admin_cutover_enabled`
 * (`platform_settings`), ligável numa tela do admin. A chave ficou ligada em
 * PROD desde a virada e a tela saiu; o redirecionamento passou a ser
 * incondicional e as telas antigas de admin dentro do CRM/app foram apagadas.
 *
 * O ambiente vem do `VITE_APP_ENV` (injetado em runtime pelo container): `hml`
 * vai para o admin do HML; qualquer outro valor vai para o de PROD — nunca o
 * contrário (falhar para o lado de PROD só leva à tela de login de lá).
 */
export const URL_DO_ADMIN_PROD = "https://admin.playprosport.com.br";
export const URL_DO_ADMIN_HML = "https://admin-hml.playprosport.com.br";

export function urlDoAdmin(ambiente: string | null | undefined): string {
  return (ambiente ?? "").toLowerCase() === "hml" ? URL_DO_ADMIN_HML : URL_DO_ADMIN_PROD;
}

/**
 * `/admin/platform-fees?x=1` → `<admin>/platform-fees?x=1`. Só tira o prefixo
 * `/admin` inteiro (não casa `/administracao`, `/admins`).
 */
export function destinoNoAdmin(
  ambiente: string | null | undefined,
  pathname: string,
  search: string,
): string {
  const caminho = pathname.replace(/^\/admin(?=\/|$)/, "") || "/";
  return `${urlDoAdmin(ambiente)}${caminho}${search}`;
}
